document.addEventListener("DOMContentLoaded", () => {
  const elements = {
    allMenus: () => Array.from(document.querySelectorAll("[data-navigation]")),
    contextualMenus: (handle) =>
      Array.from(document.querySelectorAll(`[data-navigation="${handle}"]`)),
  };

  let currentContext = window.navigation.current.context;  

  const availableContexts = ["mens", "womens"];

  if (document.body.classList.contains('template-collection') && currentContext == 'menu') {
    currentContext = document.getElementById('collection-tag').textContent;
  } 

  // We need to wait until the mobile navigation has been cloned, otherwise the event listeners
  // will never get attached to cloned Men/Women/Home links. This isn't the nicest way but
  // it's the most reliable way of doing it, right now.
  setTimeout(function () {
    // Update the session context when we click one of the three "Men", "Women", or "Home" links.
    [...document.querySelectorAll("[data-update-session-context]")].forEach(
      (link) => {
        let newContext = `${link.dataset.updateSessionContext}s`;

        link.addEventListener("click", () => {
          this.setContextCookie(newContext);
        });
      }
    );
  }, 500);

 if (!currentContext) {
    currentContext = this.getContextCookie();
  }
  
  // Set the session context only if we don't already have one
  if (availableContexts.includes(currentContext) || !sessionContext) {
    this.setContextCookie(currentContext);
    sessionContext = this.getContextCookie();
  }

  let allLinks = document.getElementsByClassName(
    "announcement-bar__link-active"
  );
  Array.from(allLinks).forEach((link) =>
    link.classList.remove("announcement-bar__link-active")
  );

  if (sessionContext) {
    window.navigation.session = {
      context: sessionContext,
      handle: `main-${sessionContext}`,
    };
    
    elements
      .allMenus()
      .forEach((menu) => menu.classList.remove("navigation--active"));
    elements
      .contextualMenus(`main-${sessionContext}`)
      .forEach((menu) => menu.classList.add("navigation--active"));
  }

  // sessionContext pulls the text content of the link
  // in order to keep the current system, we need to trim sessionContext to read either 'wom' or 'men'
  if (sessionContext) {
    sessionContext = sessionContext.substring(0, 3);
    
    let link = document.getElementById(`link-${sessionContext}`);
    link.classList.add("announcement-bar__link-active");
    
    let link_mobile = document.querySelector(`.${sessionContext}-mob`);
    link_mobile.classList.add("announcement-bar__link-active-mob");
  }
});

function setContextCookie(value) {
  var expires = "";
  var date = new Date();
  date.setMonth( date.getMonth() + 5 );
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  expires = "; expires=" + date.toUTCString();
  document.cookie =
    "navigation-context=" + (value || "") + expires + "; path=/";
}

function getContextCookie() {
  const value = `; ${document.cookie}`;
  const parts = value.split("; navigation-context=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function deleteContextCookie() {
  document.cookie =
    "navigation-context=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
